import { useContext } from "react";
import { useSelector } from "react-redux";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  logOut(): void;
}

function useLogOut(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isLogOutRequestPending),
    isRequestSuccess: useSelector(selector.isLogOutRequestSuccess),
    isRequestFailure: useSelector(selector.isLogOutRequestFailure),
    logOut: core.logOut,
  };
}

export { useLogOut };
